module.exports = __webpack_public_path__ + "assets/img/btn-view-4a5ecfdb.png";